export var GET_ALL_BRANDS = '[Brands] Get All';
export var GET_ALL_BRANDS_SUCCESS = '[Brands] Get All Success';
export var GET_ALL_BRANDS_ERROR = '[Brands] Get All Error';
export var GET_BRAND = '[Brands] Get Brand';
export var GET_BRAND_SUCCESS = '[Brands] Get Brand Success';
export var GET_BRAND_ERROR = '[Brands] Get Brand Error';
export var ADD_BRAND = '[Brand] Add';
export var ADD_BRAND_SUCCESS = '[Brand] Add Success';
export var ADD_BRAND_ERROR = '[Brand] Add Error';
export var UPDATE_BRAND = '[Brand] Update';
export var UPDATE_BRAND_SUCCESS = '[Brand] Update Success';
export var UPDATE_BRAND_ERROR = '[Brand] Update Error';
export var GET_BRAND_MANAGERS = '[Brand] Get Brand Managers';
export var GET_BRAND_MANAGERS_SUCCESS = '[Brands] Get Brand Managers Success';
export var GET_BRAND_MANAGERS_ERROR = '[Brands] Get Brand Managers Error';
var GetAllBrands = /** @class */ (function () {
    function GetAllBrands() {
        this.type = GET_ALL_BRANDS;
    }
    return GetAllBrands;
}());
export { GetAllBrands };
var GetAllBrandsSuccess = /** @class */ (function () {
    function GetAllBrandsSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_BRANDS_SUCCESS;
    }
    return GetAllBrandsSuccess;
}());
export { GetAllBrandsSuccess };
var GetAllBrandsError = /** @class */ (function () {
    function GetAllBrandsError(payload) {
        this.payload = payload;
        this.type = GET_ALL_BRANDS_ERROR;
    }
    return GetAllBrandsError;
}());
export { GetAllBrandsError };
var GetBrand = /** @class */ (function () {
    function GetBrand(payload) {
        this.payload = payload;
        this.type = GET_BRAND;
    }
    return GetBrand;
}());
export { GetBrand };
var GetBrandSuccess = /** @class */ (function () {
    function GetBrandSuccess(payload) {
        this.payload = payload;
        this.type = GET_BRAND_SUCCESS;
    }
    return GetBrandSuccess;
}());
export { GetBrandSuccess };
var GetBrandError = /** @class */ (function () {
    function GetBrandError(payload) {
        this.payload = payload;
        this.type = GET_BRAND_ERROR;
    }
    return GetBrandError;
}());
export { GetBrandError };
var AddBrand = /** @class */ (function () {
    function AddBrand(payload) {
        this.payload = payload;
        this.type = ADD_BRAND;
    }
    return AddBrand;
}());
export { AddBrand };
var AddBrandSuccess = /** @class */ (function () {
    function AddBrandSuccess(payload) {
        this.payload = payload;
        this.type = ADD_BRAND_SUCCESS;
    }
    return AddBrandSuccess;
}());
export { AddBrandSuccess };
var AddBrandError = /** @class */ (function () {
    function AddBrandError(payload) {
        this.payload = payload;
        this.type = ADD_BRAND_ERROR;
    }
    return AddBrandError;
}());
export { AddBrandError };
var UpdateBrand = /** @class */ (function () {
    function UpdateBrand(payload) {
        this.payload = payload;
        this.type = UPDATE_BRAND;
    }
    return UpdateBrand;
}());
export { UpdateBrand };
var UpdateBrandSuccess = /** @class */ (function () {
    function UpdateBrandSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_BRAND_SUCCESS;
    }
    return UpdateBrandSuccess;
}());
export { UpdateBrandSuccess };
var UpdateBrandError = /** @class */ (function () {
    function UpdateBrandError(payload) {
        this.payload = payload;
        this.type = UPDATE_BRAND_ERROR;
    }
    return UpdateBrandError;
}());
export { UpdateBrandError };
var GetBrandManagers = /** @class */ (function () {
    function GetBrandManagers() {
        this.type = GET_BRAND_MANAGERS;
    }
    return GetBrandManagers;
}());
export { GetBrandManagers };
var GetBrandManagersSuccess = /** @class */ (function () {
    function GetBrandManagersSuccess(payload) {
        this.payload = payload;
        this.type = GET_BRAND_MANAGERS_SUCCESS;
    }
    return GetBrandManagersSuccess;
}());
export { GetBrandManagersSuccess };
var GetBrandManagersError = /** @class */ (function () {
    function GetBrandManagersError(payload) {
        this.payload = payload;
        this.type = GET_BRAND_MANAGERS_ERROR;
    }
    return GetBrandManagersError;
}());
export { GetBrandManagersError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/store/actions/brand.action.ts.pre-build-optimizer.js